import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NbAuthSocialLink } from '@nebular/auth';
import { Account, AccountData } from '../../../../@core/data/account.data';

@Component({
  selector: 'dpay-register',
  styleUrls: ['./change-password.component.scss'],
  templateUrl: './change-password.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChangePasswordComponent {
  redirectDelay: number = 0;
  showMessages: any = {};
  strategy: string = '';
  submitted = false;
  loading: boolean;
  errors: string[] = [];
  messages: string[] = [];
  user: Account = {};
  socialLinks: NbAuthSocialLink[] = [];
  requestToken = "";


  constructor(protected service: AccountData,
    protected cd: ChangeDetectorRef,
    protected router: Router,
    private route: ActivatedRoute
  ) {

    route.queryParams
      .subscribe(params => {
        this.requestToken = params['token'];
      });
  }

  changePassword(): void {
    this.submitted = true;
    this.loading = true;
    this.messages = [];
    this.service
      .changePassword(this.requestToken, this.user.password)
      .pipe()
      .subscribe({
        next: () => {
          this.messages.push("Senha alterada com sucesso. Por favor efetue login clicando no link abaixo.")
          this.loading = false;
          this.cd.detectChanges();
        },
        error: (failures: { error: { errorMessage: string; }[]; }) => {
          this.submitted = false;
          this.loading = false;
          this.errors = [];
          failures.error.forEach((err: { errorMessage: string; }) => {
            this.errors.push(err.errorMessage);
          });
          this.cd.detectChanges();
        }
      });
  }
}
